// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"74e8061b","959":"7b0fd7ef"}[chunkId] + ".chunk.js";
};